(function () {
  'use strict';

  var sbbNamespace = window.__SBB__ = window.__SBB__ || {};
  var ScaleBarBuilder = sbbNamespace.ScaleBarBuilder;
  var parseNumber = sbbNamespace.parseNumber;
  var mmPerCm = sbbNamespace.mmPerCm;
  var parseJsonObject = sbbNamespace.parseJsonObject;
  var parseCssColor = sbbNamespace.parseCssColor;
  var parseOpaqueCssColor = sbbNamespace.parseOpaqueCssColor;
  var mixColors = sbbNamespace.mixColors;
  var colorToCss = sbbNamespace.colorToCss;
  var isTransparentColorValue = sbbNamespace.isTransparentColorValue;

  if (!ScaleBarBuilder || !parseNumber || !mmPerCm || !parseJsonObject || !parseCssColor || !parseOpaqueCssColor || !mixColors || !colorToCss || !isTransparentColorValue) {
    return;
  }

  var MM_PER_CM = mmPerCm;


  ScaleBarBuilder.prototype.readRuntimeConfig = function () {
    var dataset = (this.root && this.root.dataset) || {};
    var defaultTagBase = './assets/tags';
    var tagAssetsBase = String(dataset.tagAssetsBase || defaultTagBase).trim().replace(/\/$/, '');
    var inlineConfig = parseJsonObject(dataset.sbbConfig) || {};
    var themeMode = String(dataset.sbbThemeMode || 'auto').trim().toLowerCase();

    if (inlineConfig.tagAssetsBase && typeof inlineConfig.tagAssetsBase === 'string') {
      tagAssetsBase = inlineConfig.tagAssetsBase.trim().replace(/\/$/, '') || tagAssetsBase;
    }
    if (inlineConfig.themeMode && typeof inlineConfig.themeMode === 'string') {
      themeMode = inlineConfig.themeMode.trim().toLowerCase();
    }
    if (themeMode !== 'auto' && themeMode !== 'host' && themeMode !== 'custom') {
      themeMode = 'auto';
    }

    return {
      tagAssetsBase: tagAssetsBase || defaultTagBase,
      themeMode: themeMode
    };
  };


  ScaleBarBuilder.prototype.findHostElement = function (selector) {
    if (!selector) {
      return null;
    }
    var candidates = document.querySelectorAll(selector);
    for (var i = 0; i < candidates.length; i += 1) {
      var node = candidates[i];
      if (!this.root.contains(node)) {
        return node;
      }
    }
    return null;
  };


  ScaleBarBuilder.prototype.getHostStyleValue = function (element, propertyName) {
    if (!element || !propertyName) {
      return '';
    }
    var computed = window.getComputedStyle(element);
    var value = computed ? computed[propertyName] : '';
    return value || '';
  };


  ScaleBarBuilder.prototype.resolveThemeMode = function () {
    var mode = this.runtimeConfig.themeMode || 'auto';
    if (mode === 'host') {
      return 'host';
    }
    if (mode === 'custom') {
      return 'custom';
    }
    if (window.Shopify || document.documentElement.classList.contains('shopify-design-mode')) {
      return 'host';
    }
    if ((document.body && document.body.className || '').indexOf('template-') !== -1) {
      return 'host';
    }
    return 'custom';
  };


  ScaleBarBuilder.prototype.applyHostThemeTokens = function () {
    if (!this.root || !this.controls || !this.controls.shell) {
      return;
    }

    var mode = this.resolveThemeMode();
    this.controls.shell.classList.toggle('sbb-theme-host', mode === 'host');
    this.controls.shell.classList.toggle('sbb-theme-custom', mode !== 'host');
    if (mode !== 'host') {
      return;
    }

    var body = document.body || document.documentElement;
    var docEl = document.documentElement || body;
    var bodyBgValue = this.getHostStyleValue(body, 'backgroundColor');
    var bodyTextValue = this.getHostStyleValue(body, 'color');
    var linkEl = this.findHostElement('a, .link');
    var btnEl = this.findHostElement('.btn, button, input[type="submit"], input[type="button"]');
    var fieldEl = this.findHostElement('input, select, textarea');

    var bodyBg = parseOpaqueCssColor(bodyBgValue) ||
      parseOpaqueCssColor(this.getHostStyleValue(docEl, 'backgroundColor')) ||
      { r: 245, g: 245, b: 245, a: 1 };
    var bodyText = parseOpaqueCssColor(bodyTextValue) ||
      parseOpaqueCssColor(this.getHostStyleValue(docEl, 'color')) ||
      { r: 33, g: 37, b: 41, a: 1 };
    var accent = parseOpaqueCssColor(this.getHostStyleValue(btnEl, 'backgroundColor')) ||
      parseOpaqueCssColor(this.getHostStyleValue(linkEl, 'color')) ||
      mixColors(bodyText, { r: 255, g: 255, b: 255, a: 1 }, 0.15);

    var buttonText = parseOpaqueCssColor(this.getHostStyleValue(btnEl, 'color'));
    var borderBase = parseOpaqueCssColor(this.getHostStyleValue(fieldEl || btnEl, 'borderColor'));
    if (!borderBase || isTransparentColorValue(colorToCss(borderBase))) {
      borderBase = mixColors(bodyText, { r: 255, g: 255, b: 255, a: 1 }, 0.7);
    }

    var panel = mixColors(bodyBg, { r: 255, g: 255, b: 255, a: 1 }, 0.35);
    var panelAlt = mixColors(bodyBg, { r: 255, g: 255, b: 255, a: 1 }, 0.55);
    var softBg = mixColors(bodyBg, { r: 255, g: 255, b: 255, a: 1 }, 0.2);
    var accentSoft = mixColors(accent, { r: 255, g: 255, b: 255, a: 1 }, 0.45);
    var muted = mixColors(bodyText, bodyBg, 0.45);
    var canvasBg = mixColors(bodyBg, { r: 210, g: 218, b: 228, a: 1 }, 0.3);
    var success = { r: 31, g: 122, b: 79, a: 1 };
    var buttonTextFallback = parseCssColor(this.getHostStyleValue(btnEl, 'color')) ||
      mixColors(accent, { r: 255, g: 255, b: 255, a: 1 }, 0.85);

    this.root.style.setProperty('--sbb-font-family', this.getHostStyleValue(body, 'fontFamily') || '"Space Grotesk", "Segoe UI", sans-serif');
    this.root.style.setProperty('--sbb-bg', colorToCss(bodyBg));
    this.root.style.setProperty('--sbb-bg-soft', colorToCss(softBg));
    this.root.style.setProperty('--sbb-panel', colorToCss(panel));
    this.root.style.setProperty('--sbb-panel-alt', colorToCss(panelAlt));
    this.root.style.setProperty('--sbb-ink', colorToCss(bodyText));
    this.root.style.setProperty('--sbb-muted', colorToCss(muted));
    this.root.style.setProperty('--sbb-accent', colorToCss(accent));
    this.root.style.setProperty('--sbb-accent-soft', colorToCss(accentSoft));
    this.root.style.setProperty('--sbb-line', colorToCss(borderBase));
    this.root.style.setProperty('--sbb-line-soft', colorToCss(mixColors(borderBase, { r: 255, g: 255, b: 255, a: 1 }, 0.35)));
    this.root.style.setProperty('--sbb-success', colorToCss(success));
    this.root.style.setProperty('--sbb-blue', colorToCss(accent));
    this.root.style.setProperty('--sbb-canvas-bg', colorToCss(canvasBg));
    this.root.style.setProperty('--sbb-input-bg', colorToCss(mixColors(panelAlt, { r: 255, g: 255, b: 255, a: 1 }, 0.45)));
    this.root.style.setProperty('--sbb-on-accent', colorToCss(buttonText || buttonTextFallback));
    this.root.style.setProperty('--sbb-accent-strong', colorToCss(mixColors(accent, { r: 0, g: 0, b: 0, a: 1 }, 0.24)));
  };


  ScaleBarBuilder.prototype.addManagedListener = function (target, eventName, handler, options) {
    if (!target || typeof target.addEventListener !== 'function' || !eventName || typeof handler !== 'function') {
      return;
    }
    target.addEventListener(eventName, handler, options || false);
    this._managedListeners.push({
      target: target,
      eventName: eventName,
      handler: handler,
      options: options || false
    });
  };


  ScaleBarBuilder.prototype.removeManagedListeners = function () {
    for (var i = this._managedListeners.length - 1; i >= 0; i -= 1) {
      var listener = this._managedListeners[i];
      if (!listener || !listener.target || typeof listener.target.removeEventListener !== 'function') {
        continue;
      }
      listener.target.removeEventListener(listener.eventName, listener.handler, listener.options || false);
    }
    this._managedListeners = [];
  };


  ScaleBarBuilder.prototype.destroy = function () {
    if (this._destroyed) {
      return;
    }
    this._destroyed = true;
    this.suspendAutosave = true;
    this.stopInlineTextEditing(false);

    if (this.saveDebounceTimer) {
      clearTimeout(this.saveDebounceTimer);
      this.saveDebounceTimer = null;
    }
    if (this.exportPreviewDebounceTimer) {
      clearTimeout(this.exportPreviewDebounceTimer);
      this.exportPreviewDebounceTimer = null;
    }
    if (this.exportDpiInputDebounceTimer) {
      clearTimeout(this.exportDpiInputDebounceTimer);
      this.exportDpiInputDebounceTimer = null;
    }
    if (this.guideAnimationTimer) {
      clearTimeout(this.guideAnimationTimer);
      this.guideAnimationTimer = null;
    }

    this.removeManagedListeners();
    this.clearGuideHighlight();
    this.clearGuideSpotlight();
    this.cleanupImagePickerPreviewUrl();
    this.dragState = null;
    this.pointerDownEntity = null;
    this.hitRegions = [];

    if (this.root && this.root.__sbbMounted === this) {
      delete this.root.__sbbMounted;
    }
  };


  

  

  ScaleBarBuilder.prototype.renderScene = function (ctx, options) {
    var paper = this.getPaper();
    var widthPx = options.widthPx;
    var heightPx = options.heightPx;
    var paddingPx = options.paddingPx;
    var fitScale = options.pixelsPerMm || Math.min((widthPx - 2 * paddingPx) / paper.width, (heightPx - 2 * paddingPx) / paper.height);
    var scale = fitScale;
    var originX = options.pixelsPerMm ? 0 : (widthPx - paper.width * fitScale) / 2;
    var originY = options.pixelsPerMm ? 0 : (heightPx - paper.height * fitScale) / 2;

    if (!options.exportMode && !options.pixelsPerMm) {
      this.normalizeViewState();
      var centerXmm = Number.isFinite(this.state.viewCenterXmm) ? this.state.viewCenterXmm : (paper.width / 2);
      var centerYmm = Number.isFinite(this.state.viewCenterYmm) ? this.state.viewCenterYmm : (paper.height / 2);
      scale = fitScale * this.state.viewZoom;
      originX = widthPx / 2 - centerXmm * scale;
      originY = heightPx / 2 - centerYmm * scale;
    }

    var view = {
      fitScale: fitScale,
      scale: scale,
      originX: originX,
      originY: originY
    };

    this.isExportRender = !!options.exportMode;
    this.sceneVisualAlpha = options.exportMode ? 1 : this.getSceneVisualAlpha();
    ctx.clearRect(0, 0, widthPx, heightPx);
    ctx.fillStyle = options.exportMode ? '#ffffff' : '#dce4ea';
    ctx.fillRect(0, 0, widthPx, heightPx);

    this.drawPaperBackground(ctx, view, paper);

    var tags = this.getActiveTags();
    var points = this.getCurrentPoints();
    this.drawBackgroundNoise(ctx, view, points, paper);

    if (!options.exportMode) {
      this.drawSnapGridIfActive(ctx, view, paper);
    }

    this.hitRegions = [];
    if (this.state.showDistances) {
      this.drawDistanceLabels(ctx, view, tags, {
        drawLines: true,
        drawLabels: false,
        addLineHits: false,
        addLabelHits: false
      });
    }

    this.drawReferenceBars(ctx, view, paper, points);

    if (this.state.showDistances) {
      this.drawDistanceLabels(ctx, view, tags, {
        drawLines: false,
        drawLabels: true,
        addLineHits: true,
        addLabelHits: true
      });
    }

    this.drawAprilTagQuietZones(ctx, view, tags);
    this.drawCircularTagQuietZones(ctx, view, tags);

    for (var i = 0; i < tags.length; i += 1) {
      this.drawTag(ctx, view, paper, tags[i], i);
    }

    this.drawHomeCrosshair(ctx, view, paper);
    this.drawCutLines(ctx, view, points, paper);
    this.drawOverlayItems(ctx, view, paper, tags);
    this.drawAttribution(ctx, view, paper);
    this.drawGuideCanvasDemo(ctx, view, paper, widthPx, heightPx);

    if (!options.exportMode) {
      this.drawSelectionAndMiniToolbar(ctx, view, tags);
      this.drawPlacementGuides(ctx, view, paper, tags);
      this.drawCanvasRulers(ctx, view, paper, widthPx, heightPx);
      this.view = view;
    }

    if (options.exportMode) {
      this.isExportRender = false;
    }

    return { points: points, paper: paper };
  };


  ScaleBarBuilder.prototype.render = function () {
    var shelfFocusState = this.captureSelectionShelfFocusState();
    var skipInspectorRefresh = this.isLiveColorInputActiveIn(this.controls.inspector);
    var skipShelfRefresh = this.isLiveColorInputActiveIn(this.controls.selectionShelf);
    var result = this.renderScene(this.ctx, {
      widthPx: this.canvas.width,
      heightPx: this.canvas.height,
      paddingPx: 22 * this.pixelRatio,
      exportMode: false
    });

    this.controls.paperInfo.textContent = result.paper.label;
    this.updateSoftwareCommandOutput(this.getActiveTags());

    var referenceForReadout = null;
    if (this.state.selectedEntity && this.state.selectedEntity.type === 'reference') {
      referenceForReadout = this.getReferenceById(this.state.selectedEntity.id);
    }
    if (!referenceForReadout && Array.isArray(this.state.references) && this.state.references.length > 0) {
      referenceForReadout = this.state.references[0];
    }
    var checkerWidthMm = referenceForReadout ? referenceForReadout.cellWidthMm : this.state.checkerWidthCm * mmPerCm;
    var checkerHeightMm = referenceForReadout ? referenceForReadout.cellHeightMm : this.state.checkerHeightMm;
    var spacingMm = this.state.spacingCm * mmPerCm;
    var onePercent = spacingMm > 0 ? (100 * checkerWidthMm / spacingMm).toFixed(1) : '0.0';
    var gridMajorMm = this.getSnapGridMajorStepMm();
    var gridDivisions = this.getGridSubdivisionCount();
    var gridMinorMm = this.getGridStepMm();
    this.controls.gridRatio.textContent = 'Reference unit: ' + this.formatDistanceMm(checkerWidthMm) + ' wide x ' + this.formatDistanceMm(checkerHeightMm) + ' high (' + onePercent + '% of spacing). Snap grid: ' + this.formatDistanceMm(gridMajorMm) + ' / ' + gridDivisions + ' = ' + this.formatDistanceMm(gridMinorMm) + '.';

    if (this.state.tagType === 'apriltag') {
      var centerFilterOn = this.state.filterAprilTagCenters !== false;
      if (this.idCorrections.length > 0) {
        var correctionText = this.idCorrections
          .map(function (entry) { return 'T' + entry.index + ' ' + entry.from + '->' + entry.to; })
          .join(', ');
        this.controls.idValidity.textContent = 'Unique + viable resolver adjusted IDs (' + (centerFilterOn ? 'clear-center filter on' : 'full codebook') + '): ' + correctionText + '.';
      } else {
        this.controls.idValidity.textContent = centerFilterOn
          ? 'All active IDs are unique and clear-center viable.'
          : 'All active IDs are unique and codebook-valid.';
      }
    } else {
      if (this.idCorrections.length > 0) {
        var nonAprilCorrectionText = this.idCorrections
          .map(function (entry) { return 'T' + entry.index + ' ' + entry.from + '->' + entry.to; })
          .join(', ');
        this.controls.idValidity.textContent = 'Unique resolver adjusted IDs: ' + nonAprilCorrectionText + '.';
      } else {
        this.controls.idValidity.textContent = 'All active IDs are unique.';
      }
    }

    var outOfBounds = this.computeWarnings(result.points);
    if (outOfBounds.length > 0) {
      this.controls.warnings.textContent = 'Out of paper bounds: Tags ' + outOfBounds.join(', ');
      this.controls.warnings.style.color = '#9b2c2c';
    } else {
      this.controls.warnings.textContent = 'All tags fit inside paper.';
      this.controls.warnings.style.color = '#1f7a4f';
    }

    if (this.inlineTextEditing) {
      var activeOverlay = this.getSelectedOverlay();
      if (!activeOverlay || activeOverlay.id !== this.inlineTextEditing) {
        this.stopInlineTextEditing(true);
        return;
      }
    }

    if (!skipInspectorRefresh) {
      this.renderInspector();
    }
    if (!skipShelfRefresh) {
      this.renderSelectionShelf();
      this.restoreSelectionShelfFocusState(shelfFocusState);
    }
    this.renderLayersPanel();
    this.updateInlineTextEditorPosition();
    this.updateToolButtonStates();
    this.updateCanvasCursor();
    this.updateGuideAfterRender();
    this.queueAutosave();
  };

})();
